import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, Subscription } from 'rxjs';
import { environment } from 'src/environments/environment';
import { httpOptions } from "./headers";

@Injectable({
  providedIn: 'root'
})
export class ApiDocumentationService {

  private documentationUrl = environment.documentationUrl;
  private httpOptions = {
    headers: new HttpHeaders({
      'Content-Type':  'application/json',
      'Authorization': 'Basic ' + btoa('estimator:!Estimator')
    })
  };

  constructor(private http: HttpClient) { }

  getDocumentations(): Observable<any> {
    return this.http.get<any>(this.documentationUrl,httpOptions);
  }

  addDocumentation(obj: any): Subscription {
    return this.http.post<any>(this.documentationUrl, obj,httpOptions).subscribe();
  }

  
}
